export default function MySQL_CONCAT_WS() {
  return (
    <div>
      <h2>MySQL_CONCAT_WS</h2>    </div>
  );
}